import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'pagination-loading-overlay',
    templateUrl: './pagination-loading-overlay.component.html',
    styleUrls: ['./pagination-loading-overlay.component.scss']
})
export class PaginationLoadingOverlayComponent implements OnChanges {
    @Input() isLoading: boolean = false;
    @Input() currentPage: number = 1;
    @Input() scrollOnLoad: boolean = true;

    ngOnChanges(changes: SimpleChanges) {
        // When loading completes, scroll to top
        if (changes['isLoading'] && !this.isLoading && !changes['isLoading'].firstChange && this.scrollOnLoad) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
}
